//
//
//
//
//
//

export default {
  name: 'VPageTitle',
}
